import React, { useEffect } from 'react';
import { Box, Typography, Container, Card, CardContent, CardHeader, Divider, Link } from '@mui/material';
import Navbar from '../Navbar/Nabvar';
import Footer from '../Footer/Footer';
import QuoteBox from '../Quote/QuoteBox';

const Kontakt = () => {
    const primaryBlue = '#1F1B9E';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const cardStyle = {
        width: '100%',
        maxWidth: '1200px', // Fixed width for all cards
        mx: 'auto',
        mb: 4,
        '& .MuiCardHeader-root': {
            textAlign: 'center',
        },
        '& .MuiCardContent-root': {
            textAlign: 'center',
        }
    };

    // Custom styles for the wavy background
    const wavyBackgroundStyle = {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
                linear-gradient(to bottom right, 
                    rgba(240, 245, 255, 0.9),
                    rgba(230, 240, 255, 0.9)
                )
            `,
            zIndex: 0
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Navbar />

            {/* Top section with wavy background */}
            <Box
                sx={{
                    position: 'relative',
                    py: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '300px',
                    paddingTop: '80px',
                    paddingBottom: '-100px',
                    ...wavyBackgroundStyle
                }}
            >
                <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                    <Typography
                        variant="h1"
                        sx={{
                            color: primaryBlue,
                            mb: 4,
                            fontSize: '3.5rem',
                            fontWeight: 'bold'
                        }}
                    >
                        KONTAKT
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: primaryBlue,
                            maxWidth: '1200px',
                            mx: 'auto',
                            px: 2,
                            fontSize: '1.8rem'
                        }}
                    >
                        BM-MAPS ist eine Kooperation des Departments Innovationsmanagement der FH CAMPUS 02, der TIME Research Area der RWTH Aachen und des INNOLABs der FH CAMPUS 02.
                    </Typography>
                </Box>
            </Box>

            {/* Hiking image section */}
            {/*<Box*/}
            {/*    sx={{*/}
            {/*        width: '100%',*/}
            {/*        height: '800px',*/}
            {/*        backgroundImage: 'url("/old/wandern_kontakt.png")',*/}
            {/*        backgroundSize: 'cover',*/}
            {/*        backgroundPosition: 'center',*/}
            {/*    }}*/}
            {/*/>*/}

            {/* Contact Information Section */}
            <Box
                className="overlay-background"
                sx={{
                    position: 'relative',
                    py: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '300px',
                }}
            >

                {/* CAMPUS 02 Contact */}
                <Card sx={cardStyle}>
                    <CardHeader
                        title={
                            <Typography
                                variant="h6"
                                sx={{
                                    color: primaryBlue,
                                    fontSize: '1.6rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                Kontakt für Forschung und Entwicklung sowie Hochschul-Kooperationen
                            </Typography>
                        }
                    />
                    <CardContent>
                        <Box
                            component="img"
                            src="/old/fh_logo.png"
                            alt="CAMPUS 02 Logo"
                            sx={{
                                maxWidth: '300px',
                                mb: 4,
                                mx: 'auto',
                                display: 'block'
                            }}
                        />

                        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: primaryBlue, fontSize: '1.3rem' }}>
                            CAMPUS 02
                            <br />
                            Fachhochschule der Wirtschaft GmbH
                            <br />
                            Department Innovationsmanagement
                            <br />
                            Körblergasse 126, 8010 Graz, Österreich
                            <br />
                            FN 131505g – LG für ZRS Graz
                            <br />
                            <Link
                                href="mailto:inno-forschung@campus02.at"
                                underline="hover"
                                sx={{ color: primaryBlue }}
                            >
                                inno-forschung@campus02.at
                            </Link>
                            <br />
                            <Link
                                href="https://www.campus02.at"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{ color: primaryBlue, fontWeight: "bold" }}
                            >
                                www.campus02.at
                            </Link>
                        </Typography>
                    </CardContent>
                </Card>

                <Divider sx={{ my: 4 }} />

                {/* INNOLAB Contact */}
                <Card sx={cardStyle}>
                    <CardHeader
                        title={
                            <Typography
                                variant="h6"
                                sx={{
                                    color: primaryBlue,
                                    fontSize: '1.6rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                Kontakt für Innovations-Begleitung und Weiterentwicklung von KMU
                            </Typography>
                        }
                    />
                    <CardContent>
                        <Box
                            component="img"
                            src="/old/innolab_logo.png"
                            alt="INNOLAB Logo"
                            sx={{
                                maxWidth: '300px',
                                mb: 4,
                                mx: 'auto',
                                display: 'block'
                            }}
                        />

                        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: primaryBlue, fontSize: '1.3rem' }}>
                            INNOLAB an der FH CAMPUS 02
                            <br />
                            Fachhochschule der Wirtschaft GmbH
                            <br />
                            Department Innovationsmanagement
                            <br />
                            Körblergasse 126, 8010 Graz/Austria
                            <br />
                            FN 131505g - LG für ZRS Graz
                            <br />
                            <Link
                                href="mailto:office@innolab.at"
                                underline="hover"
                                sx={{ color: primaryBlue }}
                            >
                                office@innolab.at
                            </Link>
                            <br />
                            <Link
                                href="https://www.innolab.at"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{ color: primaryBlue, fontWeight: "bold" }}
                            >
                                https://www.innolab.at
                            </Link>
                        </Typography>
                    </CardContent>
                </Card>

                <Divider sx={{ my: 4 }} />

                {/* RWTH Contact */}
                <Card sx={cardStyle}>
                    <CardContent>
                        <Box
                            component="img"
                            src="/old/2_logos_am_ende.png"
                            alt="RWTH Logos"
                            sx={{
                                maxWidth: '450px',
                                mb: 4,
                                mx: 'auto',
                                display: 'block'
                            }}
                        />

                        <Typography variant="body1" sx={{ lineHeight: 1.8, color: primaryBlue, fontSize: '1.3rem' }}>
                            Rheinisch-Westfälische Technische Hochschule (RWTH) Aachen
                            <br />
                            TIME Research Area
                            <br />
                            Kackertstraße 7
                            <br />
                            52072 Aachen
                            <br />
                            +49 241 80 99197
                            <br />
                            <Link
                                href="mailto:info@time.rwth-aachen.de"
                                underline="hover"
                                sx={{ color: primaryBlue }}
                            >
                                info@time.rwth-aachen.de
                            </Link>
                            <br />
                            <Link
                                href="https://www.time.rwth-aachen.de"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{ color: primaryBlue, fontWeight: "bold" }}
                            >
                                https://www.time.rwth-aachen.de
                            </Link>
                        </Typography>
                    </CardContent>
                </Card>
            </Box>

            <QuoteBox
                text="„Wer immer tut, was er schon kann, bleibt immer das, was er schon ist“"
                maxWidth="1100px"
                hasOverlay={true}
                author={"Henry Ford"}
            />

            <Footer />
        </Box>
    );
};

export default Kontakt;